import socket from '../middlewares/socket.js'
import moment from "moment";


const WSS = new socket.WSS()

const Noti = {
  namespaced: true,
  state: () => ({
    alertlist: [],
    lastAlert: [],
    dataTable: {},
  }),
  mutations: {
    alertlist(state, newValue) {
      state.alertlist = newValue;
    },
    lastAlert(state, newValue) {
      state.lastAlert = newValue;
    },
    dataTable(state, newValue) {
      state.dataTable = newValue;
    },
  },
  actions: {
    connectWSSNoti({ dispatch, commit, getters, rootGetters },{ path, callback}) {
      // console.log("path", path, callback);
      WSS.connect(path);
      WSS.emit(path, "message");
      WSS.on("connect", () => {
        console.log("socket id", WSS.socket().id);
      });
      WSS.on("disconnect", () => {
        console.log("disconnect socket id", WSS.socket().id);
      });
      WSS.on(path, (messageNew) => {
        // console.log(
        //   "messageNew",
        //   messageNew,
        //   moment().format("HH:mm:ss")
        // );
        commit('alertlist',[]);
        commit('lastAlert',[]);
        for (let i = 0; i < messageNew.message.length; i++) {
          const el = messageNew.message[i];
          // console.log(el);
          getters['alertlist'].push(el);
          if (el.alertstatus == true) {
            getters['lastAlert'].push(el);
          }
        }
        if (messageNew.Alert == true) {
           callback()
        }
        // console.log(getters['alertlist']);
        // this.alertlist.unshift()

        // if (messageNew.newAlert == "update status Success") {
        //   this.$vs.notify({
        //     title: "Disarm",
        //     text: "Disarm this alert",
        //     color: "success",
        //     position: "top-center",
        //   });
        // }else if (messageNew.newAlert == "update status Failed") {
        //   this.$vs.notify({
        //     title: "Disarm Error!",
        //     text: "Can't disarm this alert",
        //     color: "danger",
        //     position: "top-center",
        //     icon: "check",
        //   });
        // }
      });
    },
    disAlert({ dispatch, commit, getters, rootGetters },id){
      console.log(id);
      WSS.emit('updata-status', id);

    },
    disconnectWSSNoti(){
      WSS.disconnect()
    },
  },
  getters: {
    count(state) {
      return state.countA;
    },
    alertlist(state) {
      return state.alertlist;
    },
    lastAlert(state) {
      return state.lastAlert;
    },
    dataTable(state) {
      return state.dataTable;
    },
  },
};

export default Noti;
